<script setup lang="ts">
import type { TFile } from "@/api/shared/file";
import { getFileType } from "@/composables/shared/useFile.ts";
import { computed } from "vue";
import { EFileType } from "@/composables/shared/useFile";
import { useImgProxy } from "@/composables/shared/useImageProxy.ts";
import AppImg from "@/components/shared/files/AppImg.vue";

const { getImgProxyUrl } = useImgProxy();

const props = withDefaults(
  defineProps<{
    file: TFile;
    showImage?: boolean;
    size?: number;
    iconSize?: number | string;
    rounded?: boolean;
    coverImage?: boolean;
  }>(),
  {
    size: 40,
    iconSize: 24,
    rounded: true,
  }
);
const fileType = computed(() => getFileType(props.file));

const iconByType: Record<EFileType, string> = {
  [EFileType.IMAGE]: "mdi-image",
  [EFileType.AUDIO]: "mdi-music",
  [EFileType.VIDEO]: "mdi-video",
  [EFileType.DOCUMENT]: "mdi-file-document-outline",
  [EFileType.TEXT]: "mdi-file-document-outline",
  [EFileType.APPLICATION]: "mdi-application",
  [EFileType.MODEL]: "mdi-cube-outline",
  [EFileType.UNKNOWN]: "mdi-file-question-outline",
};

const icon = computed(() => iconByType[fileType.value] ?? iconByType[EFileType.UNKNOWN]);
</script>

<template>
  <app-img
    v-if="fileType === EFileType.IMAGE && showImage && !!props.file.file"
    :src="getImgProxyUrl(props.file.file, 'xs')"
    :width="size"
    :height="size"
    :class="rounded ? 'tw:rounded' : ''"
    :cover="coverImage"
  />
  <div
    v-else
    class="tw:flex tw:items-center tw:justify-center"
    :class="rounded ? 'tw:rounded' : ''"
    :style="{ width: `${size}px`, height: `${size}px` }"
  >
    <v-icon
      :icon="icon"
      :size="iconSize"
    />
  </div>
</template>

<style scoped></style>
